import api from "@/services/api";
import type {
	ExpenseConsolidatedByPlateFilters,
	ExpenseConsolidatedByPlatePaginatedResponse,
} from "../types";

export async function getExpenseConsolidatedByPlate(
	payload: ExpenseConsolidatedByPlateFilters
) {
	const { startDate, endDate, PageNumber, PageSize, VehicleIds } = payload;

	const params = new URLSearchParams({
		startDate,
		endDate,
		PageNumber: String(PageNumber),
		PageSize: String(PageSize),
	});

	if (VehicleIds) {
		for (const id of VehicleIds) {
			params.append("VehicleIds", id);
		}
	}

	const { data } = await api.get<ExpenseConsolidatedByPlatePaginatedResponse>(
		"/api/expenses/reports/consolidated-by-plate",
		{
			params,
		}
	);

	return data;
}
